// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
import React from "react";
export function StatusColumnFormatter(cellValue, res) {
  const getLabelCssClasses = () => {
    return `label label-lg label-light-danger
      } label-inline`;
  };
  const getLabelCssClassesForSuccess = () => {
    return `label label-lg label-light-success
       label-inline`;
  };
  const getLabelCssClassesForTrial = () => {
    return `label label-lg label-light-warning
       label-inline`;
  };
  
  if (res.paymentinfos && res.paymentinfos.is_intrial === true) {
    return (
      <span className={getLabelCssClassesForTrial()}>
        In-trial
      </span>
    );
  }else{
    if (res.status === "active" || res.status === "yes") {
      return (
        <span className={getLabelCssClassesForSuccess()}>
          Active
        </span>
      );
    } else {
      return (
        <span className={getLabelCssClasses()}>
          Inactive
        </span>
      );
    }
  }

  
}
